import apolloClient from '@/store/apollo';

import CreateBookingGql from '@/extensions/event-manager/store/graphql/mutations/CreateBooking.gql';

export default {
    create: (booking) =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreateBookingGql,
                    variables: { booking },
                })
                .then(({ data }) => resolve(data.EX_EVNT_CreateBooking))
                .catch((error) => reject(error.message));
        }),
};
